import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getIsFilterApplied } from "@/utilities/utils";

import {
  updatePagination,
  updateFilters,
  fetchBankShortlistCandidates,
  setBankShortListCandidatesLoading,
} from "../../../../reducers/clientcreatejob";
import TableSearch from "../../../common/client/dataTables/TableSearch";

/**
 * A function for handling search and filters in the UI.
 *
 * @param {Event} e - The event object
 * @return {JSX.Element} The rendered UI component
 */
export const SearchFilter = () => {
  const { filters, pagination } = useSelector((state) => state.clientCreateJob);
  const filterApplied = getIsFilterApplied(filters);
  const dispatch = useDispatch();
  /**
   * A function that handles the search event.
   *
   * @param {Event} e - the event triggering the search
   * @return {void}
   */
  const handleSearch = (e) => {
    dispatch(updateFilters({ search: e.target.value }));
  };
  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      dispatch(setBankShortListCandidatesLoading(true));
      dispatch(
        updatePagination({
          ...pagination,
          currentPage: 1,
          isLastPage: false,
        }),
      );
      dispatch(fetchBankShortlistCandidates(filters));
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [filters.search]);

  return (
    <div className="SearchFilter_Wrapper">
      <div className="flex gap-[20px]">
        <TableSearch val={filters.search} handleChange={handleSearch} />
      </div>
    </div>
  );
};
